import type { SxProps, Theme } from '@mui/material';
import { colors } from '../styles/theme/colors';

/** Login-only brand tokens (panel is always light over the dark SVG backdrop). */
export const loginBrand = {
  display: '"Space Grotesk", sans-serif',
  body: '"Outfit", sans-serif',
  ink: '#0B1F38',
  accent: colors.success.main,
  label: '#334155',
  muted: '#94A3B8',
  mutedStrong: '#475569',
  fieldBg: colors.grey[50],
  fieldBorder: 'rgba(12, 187, 154, 0.45)',
  error: colors.error.dark,
  checkboxIdle: '#CBD5E1',
} as const;

export const loginFieldSx: SxProps<Theme> = {
  mb: 2.5,
  '& .MuiOutlinedInput-root': {
    backgroundColor: loginBrand.fieldBg,
    borderRadius: '12px',
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
    '& fieldset': {
      borderColor: loginBrand.fieldBorder,
    },
    '&:hover fieldset': {
      borderColor: loginBrand.accent,
    },
    '&.Mui-focused': {
      backgroundColor: colors.background.default,
      boxShadow: '0 0 0 3px rgba(12, 187, 154, 0.16)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#0BB296',
      borderWidth: '2px',
    },
  },
  '& .MuiInputBase-input': {
    py: 1.55,
    fontFamily: loginBrand.body,
    fontSize: '0.95rem',
  },
};

export const loginPanelSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  maxWidth: '26rem',
  mx: 'auto',
  borderRadius: '20px',
  bgcolor: 'rgba(255, 255, 255, 0.96)',
  border: '1px solid rgba(255, 255, 255, 0.55)',
  boxShadow: '0 20px 50px rgba(3, 14, 32, 0.45)',
  overflow: 'hidden',
  animation: 'loginPanelIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) both',
  '@keyframes loginPanelIn': {
    from: { opacity: 0, transform: 'translateY(14px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};

export const loginLabelSx: SxProps<Theme> = {
  display: 'block',
  mb: 0.75,
  fontFamily: loginBrand.body,
  fontWeight: 600,
  fontSize: '0.85rem',
  color: loginBrand.label,
};
